import { THEME_COLORS } from '../colors/types';
import { PREFIX } from '../constants';

export function getColor(color: keyof THEME_COLORS) {
  return `var(${PREFIX.COLOR}${color})`;
}
